<div class="contact-view onsip-grid-placement">
  <div class="first-column">
    <h1>Address</h1>
    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.COMPANY" | translate }}</div>
      <div>{{ organization.contact.organization || "N/A" }}</div>
    </section>

    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.ADDRESS" | translate }}</div>
      <div>{{ organization.contact.address || "N/A" }}</div>
    </section>

    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.CITY" | translate }}</div>
      <div>{{ organization.contact.city || "N/A" }}</div>
    </section>

    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.STATE" | translate }}</div>
      <div>{{ organization.contact.state || "N/A" }}</div>
    </section>

    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.ZIPCODE" | translate }}</div>
      <div>{{ organization.contact.zipcode || "N/A" }}</div>
    </section>
  </div>
  <div class="second-column">
    <h1>Contact</h1>
    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.CONTACT_NAME" | translate }}</div>
      <div>{{ organization.contact.name || "N/A" }}</div>
    </section>

    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.EMAIL_ADDRESS" | translate }}</div>
      <div>{{ organization.contact.email || "N/A" }}</div>
    </section>

    <section class="contact-view__item">
      <div class="mat-body-1 property-header">{{ "ADD_ENTERPRISE.PHONE_NUMBER" | translate }}</div>
      <div>{{ organization.contact.phone || "N/A" }}</div>
    </section>
  </div>

  <div class="contact-view__controls">
    <button mat-flat-button class="toggle-button" color="primary" (click)="togglePanel()">
      {{ "ONSIP_I18N.EDIT" | translate }}
    </button>
  </div>
</div>
